import { Component, OnInit, OnDestroy, ViewChild, Input, AfterViewInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { IonContent, ModalController } from '@ionic/angular';
import { Logger } from 'src/app/api/helper/app-error-logger';
import { AuftragEx } from 'src/app/api/model/model';

@Component({
    selector: 'app-barcode-modal',
    templateUrl: './barcode-modal.page.html',
    styleUrls: ['./barcode-modal.page.scss'],
    standalone: false
})
export class BarcodeModalPage implements OnInit, OnDestroy, AfterViewInit {
    log = new Logger('BarcodeModalPage');

    @ViewChild('content', { read: IonContent, static: true }) content: IonContent;

    subscriptions: Subscription[] = [];

    @Input() titel: string;
    @Input() barcode: string;

    isVisible = false;

    constructor(
        private modalController: ModalController) { }

    ngOnInit() {
    }

    ngAfterViewInit(): void {
        this.log?.info('ngAfterViewInit');
    }

    ngOnDestroy() {
        this.log?.debug('ngOnDestroy');

        this.subscriptions.forEach(p => p.unsubscribe());
        this.subscriptions = [];
    }

    async ionViewWillEnter() {
    }

    ionViewDidEnter() {
    }

    ionViewWillLeave() {
    }

    onClose() {
        this.dismiss();
    }

    dismiss() {
        // using the injected ModalController this page
        // can "dismiss" itself and optionally pass back data
        this.modalController.dismiss({
            'dismissed': true
        });
    }
}
